export default price => {
  const formatter = price.replace(/,/g, '')
  // formatter = parseInt(formatter, 10)

  return formatter
}
